/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {InputComponent} from '../../input/input/input.component';
import {InputDataValidatorResult} from '../../../api/generic/models/input-data-validator-result.model';
import {InputDatepickerComponent} from '../../input/input-datepicker/input-datepicker.component';

export function inputDataValidatorText(inputType: InputComponent, value: string): InputDataValidatorResult<string> {
    const isValid = inputType.isValid && !!value;
    return {value, isValid};
}

export function inputDataValidatorDate(inputType: InputDatepickerComponent,
                                       value: number,
                                       hasErrorMessages: boolean,
                                       required: boolean): InputDataValidatorResult<number> {
    let isValid = inputType.isValid && !hasErrorMessages;
    if (required) {
        isValid = isValid && value != null && !isNaN(value);
    }
    return {value, isValid};
}
